import type { Metadata } from "next";
import type { Lang } from "./i18n";

// Absolute origin for canonicals, sitemap, JSON-LD and llms.txt. Set SITE_URL in production.
export const SITE_URL = (process.env.SITE_URL ?? "http://localhost:3006").replace(/\/+$/, "");
// An open production site without SITE_URL would publish localhost canonicals, sitemap entries and share images.
if (!process.env.SITE_URL && process.env.SITE_LOCKED === "0" && process.env.NODE_ENV === "production") {
  throw new Error("SITE_URL must be set when the site is open (SITE_LOCKED=0)");
}
export const abs = (path: string) => `${SITE_URL}${path}`;

export const OG_LOCALE: Record<Lang, string> = {
  en: "en_GB", de: "de_DE", es: "es_ES", fr: "fr_FR", pt: "pt_BR", pl: "pl_PL", cs: "cs_CZ", sk: "sk_SK",
  hu: "hu_HU", lt: "lt_LT", ru: "ru_RU", uk: "uk_UA", tr: "tr_TR", zh: "zh_CN",
};

/**
 * Page metadata. The layout adds "— DragonDrop" and owns openGraph/twitter, which inherit this title and description
 * (a page-level openGraph would replace the inherited share image). path = canonical; null = private page (noindex).
 */
export const meta = (path: string | null, title: string, description: string): Metadata => ({
  title,
  description,
  ...(path ? { alternates: { canonical: path } } : { robots: { index: false, follow: true } }),
});

const WEAR: Record<string, string> = { FN: "Factory New", MW: "Minimal Wear", FT: "Field-Tested", WW: "Well-Worn", BS: "Battle-Scarred" };
/** "Kilowatt Case", "AWP Case", "Katowice 2019 Legends (Holo/Foil) Capsule": the name plus its kind unless it already says it. */
export const caseLabel = (name: string, cat?: string) =>
  /\b(case|capsule|collection|package)$/i.test(name) ? name : `${name} ${cat === "sticker" ? "Capsule" : "Case"}`;

/** Alt text for a skin image: its market name with the full wear. */
export const itemAlt = (it: { n: string; w?: string }) => (it.w && WEAR[it.w] ? `${it.n} (${WEAR[it.w]})` : it.n);
